import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import "../Common/css/styles.css";
import learning from "../Assets/Images/learning_materials.png";
import assignments from "../Assets/Images/assignments.png"
import recordings from "../Assets/Images/recordings.png";
import instructorIcon from "../Assets/Images/instructor.png";
import chatIcon from "../Assets/Images/chat.png";
import { Box, Button, Dialog, DialogActions, DialogContent, IconButton, Modal, Tooltip, Typography } from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import "../Common/css/recordIcon.css"
import text from "../Assets/Text/Text.json"
import zoom from "../Assets/Images/zoom_meeting.png";
import { getCurrentMeeting, getRecording } from 'src/Services/zoom_api';
import camera from "../Assets/Images/video-camera.png";
import { getInstructors } from 'src/Services/instructor_api';
import { CalendarOutlined, CloseCircleFilled } from '@ant-design/icons';
import "../Common/css/modal.css"
import { getMaterial, getMaterialPaths } from 'src/Services/materials_api';
import Spinner from 'src/Components/Spinner';
import { addAnswers, getAssignment, getAssignmentPaths, getSubmissions } from 'src/Services/assignments_api';
import { AssignmentTurnedInOutlined, Description, DomainVerification } from '@mui/icons-material';
import { Drawer } from '@mui/material';
import { Close } from '@mui/icons-material'; // or your custom close icon
import CustomAlert from 'src/Components/Alerts';
import StudentInstructorChat from 'src/Components/StudentInstructorChat';
import { chatApi } from 'src/Services/chat_api';
import { getSubjectId, updateAttendance } from 'src/Services/attendance_api';

export const Subject = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { course } = location.state || {};

    const [loading, setLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const isSubmittingRef = useRef(false);
    const [submitConfirmOpen, setSubmitConfirmOpen] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const [isExpanded1, setIsExpanded1] = useState(false);
    const [isExpanded2, setIsExpanded2] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [currentLink, setCurrentLink] = useState("")
    const [isVisible, setIsVisible] = useState(false)
    const [matDialog, setMatDialog] = useState(false)

    const [materialPaths, setMaterialPaths] = useState<any[]>([])
    const [assignmentPaths, setAssignmentPaths] = useState<any[]>([])
    const [expandedPaths, setExpandedPaths] = useState<Set<string>>(new Set());
    const [expandedAssignmentPaths, setExpandedAssignmentPaths] = useState<Set<string>>(new Set());
    const [pdfUrlA, setPdfUrlA] = useState<string | null>(null);
    const [pdfUrl, setPdfUrl] = useState<string | null>(null);
    const [fName, setFName] = useState("")
    const [node, setNode] = useState(0)
    const [attempts, setAttempts] = useState(0)
    const [usedAttempts, setUsedAttempts] = useState(0)
    const [marks, setMarks] = useState<any>()
    const [markingStatus, setMarkingStatus] = useState<any>()
    const [endDate, setEndDate] = useState("")

    const [recordingsLinks, setRecordingsLinks] = useState<any[]>([])
    const [instructors, setInstructors] = useState<any[]>([])

    const [searchQuery, setSearchQuery] = useState("");

    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [dragActive, setDragActive] = useState(false);
    const [selectedFile, setSelectedFile] = useState<any>(null);

    const [alertOpen, setAlertOpen] = useState(false);
    const [alertDescription, setAlertDescription] = useState("");
    const [alertType, setAlertType] = useState<"success" | "error" | "warning">("success")
    const [openChat, setOpenChat] = useState(false);
    const [isChatStarted, setIsChatStarted] = useState(false);
    const [conversationId, setConversationId] = useState(0);
    const [subjectId, setSubjectId] = useState<any>(null)

    const userId = sessionStorage.getItem("userId")

    const [submissions, setSubmissions] = useState<any[]>([])
    const [instructorId, setInstructorId] = useState<any>("")
    const [instructorName, setInstructorName] = useState<any>("")
    const [submissionsModalOpen, setSubmissionsModalOpen] = useState(false)
    const [viewingSubmissions, setViewingSubmissions] = useState<any[]>([])

    const handleCheckConversationStatus = async (insId:any) => {
        try {
            const res = await chatApi.getChatsStatus(Number(userId));

            // Filter instructor with id = insId
            const instructor = res.find((item: any) => item.id === insId);

            if (!instructor) {
                //console.log("Instructor not found");
                return;
            }

            // Check existing conversation
            if (instructor.hasExistingConversation) {
                //console.log("Conversation already exists. ID:", instructor.conversationId);
                setIsChatStarted(true);
                setConversationId(instructor.conversationId);
            } else {
                //console.log("No conversation exists for instructor:", instructor.id);
                setIsChatStarted(false);
                setConversationId(0);
            }

        } catch (error) {
            console.error(error);
        }
    };

    const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        const files = e.dataTransfer.files;
        if (files && files.length > 0) {
            const file = files[0];
            const isPdf = file.type === "application/pdf" || file.name.toLowerCase().endsWith(".pdf");
            if (!isPdf) {
                showAlert("Only PDF files are allowed", "warning");
                setDragActive(false);
                return;
            }
            // place into correct state depending on which modal is open
            setSelectedFile([file]);
        }
        setDragActive(false);
    };


    const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(true);
    };

    const handleDragLeave = () => {
        setDragActive(false);
    };

    const toggleDrawer = (open: boolean) => () => {
        setIsDrawerOpen(open);
    };

    const token = sessionStorage.getItem("token") || "";
    const stream = sessionStorage.getItem("stream1") || "";

    const handleOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };


    const streamTitleRef = useRef<HTMLSpanElement>(null);

    useEffect(() => {
        if (!course) {
            navigate("/");
        } else {
            window.scrollTo(0, 0);
        }

        handleGetRecordings()
        handleGetCurrentSession()
        handleGetInstructors()
        handleGetMaterialPaths()
        handleGetAssignmentPaths()
    }, [course, navigate]);

    const handleGetMaterialPaths = async () => {
        try {
            const response = await getMaterialPaths(course.split(" :")[0], stream, course.split(": ")[1] === stream ? null : course.split(": ")[1], token)
            setMaterialPaths(response.data)
        } catch (error) {
            console.error(error);
        }
    }

    const handleGetAssignmentPaths = async () => {
        try {
            const response = await getAssignmentPaths(course.split(" :")[0], stream, course.split(": ")[1] === stream ? null : course.split(": ")[1], token)
            setAssignmentPaths(response.data)
        } catch (error) {
            console.error(error);
        }
    }

    const handleGetRecordings = async () => {
        try {
            const res = await getRecording(course.split(" :")[0], stream, course.split(": ")[1] === stream ? null : course.split(": ")[1], token);

            const activeRecordings = res.data.filter((item: any) => item.activeStatus === true);
            setRecordingsLinks(activeRecordings);
        } catch (error) {
            console.error("Error fetching recordings:", error);
        }
    };

    const handleGetCurrentSession = async () => {
        try {
            const res = await getCurrentMeeting(course.split(" :")[0], stream, course.split(": ")[1] === stream ? null : course.split(": ")[1], token);
            if (res.data.started) {
                setIsVisible(true)
                setCurrentLink(res.data.zoomMeetingLink)
            } else {
                setIsVisible(false)
                setCurrentLink("")
            }

        } catch (error) {
            console.error("Error fetching meetings:", error);
        }
    }

    const handleGetInstructors = async () => {
        try {
            const res = await getInstructors(course.split(" :")[0], stream, course.split(": ")[1] === stream ? null : course.split(": ")[1], token);
            setInstructors(Array.isArray(res.data) ? res.data : [])
        } catch (error) {
            console.error("Error fetching instructors:", error);
        }
    };

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    const toggleExpand1 = () => {
        setIsExpanded1(!isExpanded1);
    };

    const toggleExpand2 = () => {
        setIsExpanded2(!isExpanded2);
    };

    const materials = [
        "No Content Available",
    ];

    const filteredInstructors = instructors.filter(instructor =>
        instructor.name.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const materialModalOpen = () => {
        setMatDialog(true)
    }

    const materialModalClose = () => {
        setMatDialog(false)
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '75%',
        height: '80vh',
        bgcolor: 'grey',
        border: '2px solid white',
        boxShadow: 24,
        p: 4,
        borderRadius: '10px'
    };

    const handleAssignmentViewClick = async (nodeId: any, folderId: any) => {
        setLoading(true);
        try {
            const response = await getAssignment(folderId, nodeId, token);
            const base64 = response.data.file;
            const byteCharacters = atob(base64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);

            setPdfUrlA(blobUrl); // Save it in state and show in an iframe/modal
            setLoading(false);

        } catch (error) {
            console.error(error);
        }
    };

    const handleViewClick = async (nodeId: any, folderId: any) => {
        setLoading(true);
        try {
            const response = await getMaterial(folderId, nodeId, token);
            const base64 = response.data.file;
            const byteCharacters = atob(base64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);


            setPdfUrl(blobUrl); // Save it in state and show in an iframe/modal
            setLoading(false);
        } catch (error) {
            console.error(error);
        }
    };

    const toggleAFolder = (path: string) => {
        setExpandedAssignmentPaths(prev => {
            const newSet = new Set(prev);
            if (newSet.has(path)) {
                newSet.delete(path);
            } else {
                newSet.add(path);
            }
            return newSet;
        });
    };

    const toggleFolder = (path: string) => {
        setExpandedPaths(prev => {
            const newSet = new Set(prev);
            if (newSet.has(path)) {
                newSet.delete(path);
            } else {
                newSet.add(path);
            }
            return newSet;
        });
    };

    const showAlert = (description: string, type: "success" | "error" | "warning") => {
        setAlertDescription(description);
        setAlertType(type);
        setAlertOpen(true);
    };

    const userType = sessionStorage.getItem("userType") || "";

    const handleDrawer = (fileName: any, attempts: any, end: any, nodeId: any) => {

        if(userType !== "STUDENT"){
            showAlert("Only students can submit assignments. Parents are not allowed!", "error")
            return
        }

        setFName(fileName.split(".pdf"))
        setNode(nodeId)
        setAttempts(attempts)
        setEndDate(end.split('T')[0] + ' ' + end.split('T')[1].substring(0, 5))
        setIsDrawerOpen(true)
        handleGetSubmissions(nodeId)
    }

    const handleGetSubmissions = async (node: any) => {
        try {
            const res = await getSubmissions(userId, node, token)
            setMarkingStatus(res.data[res.data.length - 1].markingStatus)
            if (res.data.length > 0) {
                setMarks(res.data[res.data.length - 1].marks)
            } else {
                setMarks(0)
            }
            setSubmissions(res.data)
            setUsedAttempts(res.data.length)
        } catch (error) {
            console.error(error);
            setUsedAttempts(0)
            setMarkingStatus(0)
            setMarks(0)
        }
    }

    const handleViewSubmissions = () => {
        if (submissions.length > 0) {
            setViewingSubmissions(submissions)
            setSubmissionsModalOpen(true)
        }
    }

    const handleViewSubmittedFile = (base64File: string) => {
        try {
            const byteCharacters = atob(base64File);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);
            window.open(blobUrl, '_blank');
        } catch (error) {
            console.error(error);
            showAlert("Failed to load submitted file", "error");
        }
    }

    const handleGetSubjectId = async () => {
        try {
            const res = await getSubjectId(token, course.split(" :")[0], stream, course.split(": ")[1] === stream ? "" : course.split(": ")[1])
            setSubjectId(res.id)           
        } catch (error) {
            setSubjectId(0)
        }
    }

    useEffect(()=>{
        handleGetSubjectId()
    },[])

    const handleMarkAttendance = async () => {
        try {
            // need to pass today date like 2025-12-10T14:01:23.202Z
            await updateAttendance(token, userId, subjectId, new Date().toISOString(), true)
        } catch (error) {
            console.error(error)            
        }
    }

    const handleSubmission = async () => {
        if (isSubmittingRef.current) {
            return;
        }

        if (!selectedFile || selectedFile.length === 0) {
            showAlert("Please select a PDF file", "warning")
            return
        }

        isSubmittingRef.current = true;
        setIsSubmitting(true);
        setLoading(true)
        const formData = new FormData();
        formData.append("File", selectedFile[0]);

        try {
            const res = await addAnswers(formData, node, userId, token)
            showAlert("Successfully submitted !", "success")
            await handleGetSubmissions(node)
            setSelectedFile(null)
        } catch (error) {
            showAlert("Submission Failed!", "error")
        } finally {
            setLoading(false)
            isSubmittingRef.current = false;
            setIsSubmitting(false);
        }
    }

    const handleSubmitClick = () => {
        if (isSubmittingRef.current) {
            return;
        }

        if (!selectedFile || selectedFile.length === 0) {
            showAlert("Please select a PDF file", "warning")
            return
        }

        setSubmitConfirmOpen(true);
    }

    // Recursively render tree structure
    const renderAssignmentTree = (nodes: any[], parentPath = '') => {
        
        //console.log(nodes);

        return nodes.map((node) => {
            const currentPath = parentPath ? `${parentPath}${node.filePath}` : node.filePath;
            const isFolder = node.children.length > 0 || node.materialAssignment.length > 0;
            const isExpanded = expandedAssignmentPaths.has(currentPath);

            return (
                <div key={node.id}>
                    <div
                        style={{ marginLeft: parentPath ? '20px' : '0px', position: 'relative', paddingRight: '40px' }}
                    >
                        <div
                            className="material-item"
                            style={{ cursor: 'pointer' }}
                            onClick={() => toggleAFolder(currentPath)}
                        >
                            <i className="material-icon">
                                {isExpanded ? '📂' : '📁'}
                            </i>
                            <span>{node.filePath.split('/').pop()}</span>
                        </div>

                        {isExpanded && (
                            <div>
                                {/* Render files (material) inside this folder */}
                                {node.materialAssignment
                                    .filter((file: any) => file.userUploadStatus === 1)
                                    .map((file: any) => (
                                    <div
                                        key={file.id}
                                        style={{
                                            marginLeft: '20px',
                                            position: 'relative',
                                            paddingRight: '40px',
                                        }}
                                    >
                                        <i className="material-icon">📄</i> <span onClick={() => handleAssignmentViewClick(node.id, file.id)}>{file.fileName}</span>
                                        <div className="upload-zone-outer" onClick={(e) => handleDrawer(file.fileName, file.attempts, file.endDateTime, file.id)}>
                                            <Description />
                                            Upload Answers
                                            <div className='due-date-label'>
                                                Due : {file.endDateTime && file.endDateTime.split('T')[0] + ' ' + file.endDateTime.split('T')[1].substring(0, 5)}
                                            </div>

                                        </div>
                                    </div>
                                ))}

                                {/* Recursively render subfolders */}
                                {renderAssignmentTree(node.children, currentPath)}
                            </div>
                        )}
                    </div>
                </div>
            );
        });
    };

    const renderMaterialTree = (nodes: any[], parentPath = '') => {
        return nodes.map((node) => {
            const currentPath = parentPath ? `${parentPath}${node.filePath}` : node.filePath;
            const isFolder = node.children.length > 0 || node.material.length > 0;
            const isExpanded = expandedPaths.has(currentPath);

            return (
                <div key={node.id}>
                    <div
                        style={{ marginLeft: parentPath ? '20px' : '0px', position: 'relative', paddingRight: '40px' }}
                    >
                        <div
                            className="material-item"
                            style={{ cursor: 'pointer' }}
                            onClick={() => toggleFolder(currentPath)}
                        >
                            <i className="material-icon">
                                {isExpanded ? '📂' : '📁'}
                            </i>
                            <span>{node.filePath.split('/').pop()}</span>

                        </div>

                        {isExpanded && (
                            <div>
                                {/* Render files (material) inside this folder */}
                                {node.material.map((file: any) => (
                                    <div
                                        key={file.id}
                                        style={{
                                            marginLeft: '20px',
                                            position: 'relative',
                                            paddingRight: '40px',
                                        }}
                                    >
                                        <i className="material-icon">📄</i> <span onClick={() => handleViewClick(node.id, file.id)}>{file.fileName}</span>
                                    </div>
                                ))}

                                {/* Recursively render subfolders */}
                                {renderMaterialTree(node.children, currentPath)}
                            </div>
                        )}
                    </div>
                </div>
            );
        });
    };

    return (
        <div className="comman-outer">
            <CustomAlert
                open={alertOpen}
                onClose={() => setAlertOpen(false)}
                description={alertDescription}
                type={alertType}
                timeout={3000}
            />
            <Drawer
                anchor="right"
                open={isDrawerOpen}
                onClose={toggleDrawer(false)}
                PaperProps={{
                    sx: {
                        width: 400,
                        backgroundColor: '#252525',
                        color: '#BABDBD',
                        p: 3,
                        borderLeft: "1px solid white",
                        zIndex: 1600, // ensures it's above regular modals
                        marginTop: "60px",
                    },
                }}
            >
                <Box sx={{ position: 'relative', height: '100%', overflowY: 'auto', paddingBottom: '50px' }}>
                    <IconButton
                        onClick={toggleDrawer(false)}
                        className='modal-hover'
                        sx={{
                            position: 'absolute', top: 0, right: 0, color: 'black', padding: "2px",
                            backgroundColor: "#FFEC00", borderRadius: "0px"
                        }}
                    >
                        <Close />
                    </IconButton>

                    <div style={{ color: "white" }} className="file-name-outer">
                        <Description style={{ fontSize: "35px" }} />
                        {fName}
                    </div>

                    <hr style={{ marginTop: "25px" }} />

                    <div style={{ marginTop: "25px", fontWeight: "bold" }}>Details & Informations</div>

                    <div className="modal-due-outer">
                        <div className="modal-due-inner">
                            <CalendarOutlined style={{ fontSize: "25px" }} />
                            <div className="mdi">
                                Assignment Due Date
                                <div style={{ color: new Date() >= new Date(endDate) ? "red !important" : "white !important" }}>{endDate}</div>
                            </div>
                        </div>
                        <div className="modal-due-inner">
                            <DomainVerification style={{ fontSize: "25px" }} />
                            <div className="mdi">
                                Left Attempts
                                <div>{attempts} Attempts | <span onClick={handleViewSubmissions} style={{ color: "#FFEC00", textDecoration: "underline", cursor: usedAttempts > 0 ? "pointer" : "default" }}>{usedAttempts} Submitted</span> </div>
                            </div>
                        </div>
                    </div>

                    <hr style={{ marginTop: "25px" }} />

                    <div style={{ marginTop: "25px", fontWeight: "bold" }}>Marking</div>

                    <div className="modal-due-outer">
                        <div className="modal-due-inner">
                            <AssignmentTurnedInOutlined style={{ fontSize: "25px" }} />
                            <div className="mdi">
                                Submission Marks
                                <div className='marks'>
                                    {marks === 0 ? markingStatus === 0 ? new Date() >= new Date(endDate) ? `0%` : "Not Submitted" : "No Marks Yet" : `${marks}%`}
                                </div>
                            </div>
                        </div>
                        {/* <div className="modal-due-inner">
                            <FactCheckOutlined style={{ fontSize: "25px" }} />
                            <div className="mdi">
                                Correct Answers
                                <div className='marks'>Not Added</div>
                            </div>
                        </div> */}
                    </div>

                    <hr style={{ marginTop: "25px" }} />

                    <div
                        className={`drop-zone1 ${dragActive ? 'active' : ''}`}
                        onDrop={handleDrop}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                    >
                        {selectedFile && selectedFile.length > 0 ? (
                            <p className="file-list">{selectedFile[0].name}</p>
                        ) : (
                            <p>Drag & drop a file here or click to browse</p>
                        )}


                        <input
                            type="file"
                            multiple
                            onChange={(e) => setSelectedFile(e.target.files)}
                            accept='application/pdf'
                        />
                    </div>

                    <button
                        className="btn upload-answers"
                        onClick={handleSubmitClick}
                        disabled={isSubmitting || attempts === usedAttempts || new Date() >= new Date(endDate) || selectedFile === null}
                    >
                        Submit
                    </button>

                </Box>
            </Drawer>

            <Dialog
                open={submitConfirmOpen}
                onClose={() => setSubmitConfirmOpen(false)}
                sx={{
                    zIndex: 20000,
                    "& .MuiPaper-root": {
                        border: "2px solid #333",
                        backgroundColor: "#1e1e1e",
                        color: "#fff",
                    },
                }}
            >
                <DialogContent dividers>
                    <Typography sx={{ fontWeight: "bold", mb: 1 }}>
                        Confirm submission
                    </Typography>
                    <Typography sx={{ color: "#95a5a6" }}>
                        Are you sure you want to submit this file?
                    </Typography>
                    {selectedFile && selectedFile.length > 0 && (
                        <Typography sx={{ color: "#BABDBD", mt: 1, fontSize: "0.9rem" }}>
                            File: {selectedFile[0].name}
                        </Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={() => setSubmitConfirmOpen(false)} disabled={isSubmitting}>
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={async () => {
                            setSubmitConfirmOpen(false);
                            await handleSubmission();
                        }}
                        disabled={isSubmitting}
                    >
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>

            <Spinner isLoading={loading} />

            <Modal
                open={Boolean(pdfUrl)}
                onClose={() => setPdfUrl(null)}
                sx={{ zIndex: 20000 }}
                slots={{ backdrop: undefined }}
            >
                <Box
                    sx={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        bgcolor: "rgba(0,0,0,0.9)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <IconButton
                        onClick={() => setPdfUrl(null)}
                        sx={{
                            position: "absolute",
                            top: 16,
                            right: 16,
                            color: "white",
                            bgcolor: "rgba(0,0,0,0.4)",
                            '&:hover': { bgcolor: "rgba(0,0,0,0.6)" },
                            zIndex: 20001,
                        }}
                    >
                        <Close />
                    </IconButton>

                    {pdfUrl && (
                        <Box
                            component="iframe"
                            src={pdfUrl}
                            sx={{ width: "100%", height: "100%", border: "none" }}
                        />
                    )}
                </Box>
            </Modal>

            <Modal
                open={Boolean(pdfUrlA)}
                onClose={() => setPdfUrlA(null)}
                sx={{ zIndex: 20000 }}
                slots={{ backdrop: undefined }}
            >
                <Box
                    sx={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        bgcolor: "rgba(0,0,0,0.9)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <IconButton
                        onClick={() => setPdfUrlA(null)}
                        sx={{
                            position: "absolute",
                            top: 16,
                            right: 16,
                            color: "white",
                            bgcolor: "rgba(0,0,0,0.4)",
                            '&:hover': { bgcolor: "rgba(0,0,0,0.6)" },
                            zIndex: 20001,
                        }}
                    >
                        <Close />
                    </IconButton>

                    {pdfUrlA && (
                        <Box
                            component="iframe"
                            src={pdfUrlA}
                            sx={{ width: "100%", height: "100%", border: "none" }}
                        />
                    )}
                </Box>
            </Modal>

            <Modal
                open={submissionsModalOpen}
                onClose={() => setSubmissionsModalOpen(false)}
                sx={{ zIndex: 15000 }}
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "600px",
                        maxHeight: "80vh",
                        bgcolor: "#252525",
                        border: "2px solid white",
                        borderRadius: "10px",
                        boxShadow: 24,
                        p: 4,
                        overflowY: "auto",
                        color: "white"
                    }}
                >
                    <IconButton
                        onClick={() => setSubmissionsModalOpen(false)}
                        sx={{
                            position: "absolute",
                            top: 8,
                            right: 8,
                            color: "black",
                            backgroundColor: "#FFEC00",
                            borderRadius: "0px",
                            padding: "2px",
                            '&:hover': { backgroundColor: "#FFD700" },
                        }}
                    >
                        <Close />
                    </IconButton>

                    <Typography variant="h5" component="h2" sx={{ fontWeight: "bold", mb: 3 }}>
                        Your Submissions
                    </Typography>

                    {viewingSubmissions.length === 0 ? (
                        <Typography sx={{ color: "#BABDBD", textAlign: "center", py: 4 }}>
                            No submissions yet
                        </Typography>
                    ) : (
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                            {viewingSubmissions.map((submission, index) => (
                                <Box
                                    key={submission.id}
                                    sx={{
                                        backgroundColor: "#1e1e1e",
                                        border: "1px solid #444",
                                        borderRadius: "8px",
                                        p: 2,
                                        cursor: "pointer",
                                        transition: "all 0.3s",
                                        '&:hover': {
                                            backgroundColor: "#2a2a2a",
                                            borderColor: "#FFEC00",
                                        }
                                    }}
                                    onClick={() => {
                                        handleViewSubmittedFile(submission.file);
                                        setSubmissionsModalOpen(false);
                                    }}
                                >
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                                        <Description sx={{ color: "#FFEC00" }} />
                                        <Typography sx={{ fontWeight: "bold", color: "white" }}>
                                            Attempt {submission.attempt}
                                        </Typography>
                                    </Box>
                                    <Typography sx={{ color: "#BABDBD", fontSize: "14px", mb: 1 }}>
                                        File: {submission.fileName}
                                    </Typography>
                                    {index === viewingSubmissions.length - 1 && (
                                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                            <Typography sx={{ color: submission.markingStatus === 0 ? "#ff9800" : "#4caf50", fontSize: "14px" }}>
                                                Status: {submission.markingStatus === 1 ? "Pending" : "Marked"}
                                            </Typography>
                                            <Typography sx={{ color: submission.marks > 0 ? "#4caf50" : "#BABDBD", fontSize: "14px", fontWeight: "bold" }}>
                                                Marks: {submission.marks > 0 ? `${submission.marks}%` : "Not Yet"}
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>
                            ))}
                        </Box>
                    )}
                </Box>
            </Modal>
            <Modal
                open={false}
                onClose={materialModalClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <IconButton
                        onClick={materialModalClose}
                        sx={{ position: 'absolute', top: 8, right: 8, color: 'black.700' }}
                    >
                        <CloseCircleFilled />
                    </IconButton>
                    <Typography id="modal-modal-title" variant="h5" component="h2" sx={{ fontWeight: 'bold' }}>
                        Add Learning Materials
                    </Typography>
                </Box>
            </Modal>
            <div className="comman-header-outer">
                <span className="stream-title-text" tabIndex={-1} ref={streamTitleRef}>
                    {course}
                </span>
                <Dialog open={openDialog} onClose={handleCloseDialog} sx={{
                    "& .MuiPaper-root": {
                        border: "2px solid #333",
                        backgroundColor: "#1e1e1e",
                        color: "#fff",
                    },
                }}>
                    <div className="center">
                        <img className='zoom-img' src={zoom} alt="" />
                    </div>
                    <DialogContent dividers>
                        <p style={{ marginBottom: '12px', fontSize: '1rem', color: '#95a5a6' }}>
                            You’re about to join a live Zoom session for <strong>{course}</strong>.
                        </p>
                        <ul style={{ paddingLeft: '1.25rem', marginBottom: '12px', color: '#95a5a6', fontSize: '0.95rem' }}>
                            <li>Please ensure your internet connection is stable.</li>
                            <li>Use headphones for a better audio experience.</li>
                            <li>Join a quiet environment for minimal distractions.</li>
                        </ul>
                        <p style={{ fontSize: '0.95rem', color: '#95a5a6' }}>
                            Click <strong>Join Now</strong> to proceed to the Zoom class in a new tab.
                        </p>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseDialog}>Cancel</Button>
                        <Button
                            variant="contained"
                            onClick={() => {
                                if(userType === "PARENT"){
                                    showAlert("Only students can join the class. Parents are not allowed!", "error")
                                    return
                                }
                                window.open(currentLink, "_blank");
                                handleCloseDialog();
                                handleMarkAttendance();
                            }}
                        >
                            Join Now
                        </Button>
                    </DialogActions>
                </Dialog>
                {isVisible && (
                    <Button
                        className="primary-btn mr"
                        variant="contained"
                        onClick={handleOpenDialog}
                        startIcon={
                            <Tooltip title="Zoom class in progress" arrow>
                                <span className="recording-wrapper">
                                    <FiberManualRecordIcon className="recording-icon" />
                                </span>
                            </Tooltip>
                        }
                    >
                        {text.subjects.joinClass}
                    </Button>
                )}

            </div>

            <div className="subject-main-outer">
                <div className="subject-main-inner1">
                    {/* <div className="subject-content">
                        <div className="learning-card">
                            <div className="card-top" onClick={toggleExpand}>
                                <img src={learning} alt="Start Here" className="card-thumb" />
                                <div className="card-info">
                                    <h3>
                                        {text.subjects.learningMaterials}
                                    </h3>
                                    <p>{text.subjects.learningMaterialsDesc}</p>
                                </div>
                                <div className="card-progress">
                                    <span>{isExpanded ? "▲" : "▼"}</span>
                                </div>
                            </div>

                            {isExpanded && (
                                <div className="card-body">
                                    {renderMaterialTree(materialPaths)}
                                </div>
                            )}
                        </div>
                    </div> */}
                    <div className="subject-content">
                        <div className="learning-card">
                            <div className="card-top" onClick={toggleExpand1}>
                                <img src={assignments} alt="Start Here" className="card-thumb" />
                                <div className="card-info">
                                    <h3>{text.subjects.assignments}</h3>
                                    <p>{text.subjects.assignmentsDesc}</p>
                                </div>
                                <div className="card-progress">
                                    <span>{isExpanded1 ? "▲" : "▼"}</span>
                                </div>
                            </div>

                            {isExpanded1 && (
                                <div className="card-body">
                                    {renderAssignmentTree(assignmentPaths)}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="subject-content">
                        <div className="learning-card">
                            <div className="card-top" onClick={toggleExpand2}>
                                <img src={recordings} alt="Start Here" className="card-thumb" />
                                <div className="card-info">
                                    <h3>{text.subjects.zoomRecordings}</h3>
                                    <p>{text.subjects.zoomRecordingsDesc}</p>
                                </div>
                                <div className="card-progress">
                                    <span>{isExpanded2 ? "▲" : "▼"}</span>
                                </div>
                            </div>

                            {isExpanded2 && (
                                <div className="card-body">
                                    {recordingsLinks.length === 0 ? (
                                        <div className="material-item">
                                            <i className="material-icon">📄</i>
                                            <span>No Content Available</span>
                                        </div>
                                    ) : (
                                        recordingsLinks.map((recording, idx) => (
                                            <div className="material-item" key={idx}>
                                                <img style={{ width: "25px" }} src={camera} alt="" />
                                                <span
                                                    onClick={() =>
                                                        navigate("/recording", {
                                                            state: { link: recording.recordLink, title: recording.title || `Recording ${idx + 1}` },
                                                        })
                                                    }
                                                    style={{ color: 'white', cursor: 'pointer' }}
                                                >
                                                    {recording.title || `Recording ${idx + 1}`}
                                                </span>
                                            </div>
                                        ))
                                    )}
                                </div>
                            )}

                        </div>
                    </div>
                </div>
                <div className="subject-main-inner2">
                    <div className="instructors-card">
                        <div className="instructors-header">
                            <h3>{text.subjects.instructors}</h3>
                        </div>
                        <div className="instructors-header">
                            <input
                                type="text"
                                placeholder="Search instructors..."
                                className="instructor-search"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                        </div>
                        <div className="instructors-list">
                            {filteredInstructors.map((instructor) => (
                                <div className="instructor-item" key={instructor.instructorId}>
                                    <img className="instructor-icon" src={instructorIcon}></img>
                                    <span className="instructor-name">{instructor.name}</span>
                                    <img className="chat-icon" onClick={() => {
                                        if(userType === "PARENT"){
                                            showAlert("Only students can access the chat. Parents are not allowed!", "error")
                                            return
                                        }
                                        setOpenChat(true)
                                        handleCheckConversationStatus(instructor.instructorId)
                                        setInstructorId(instructor.instructorId)
                                        setInstructorName(instructor.name)
                                    }} src={chatIcon}></img>
                                </div>
                            ))}
                            {filteredInstructors.length === 0 && (
                                <span style={{ textAlign: 'center', marginTop: '35px', fontSize: '25px', padding: '25px' }}><b>No instructors found.</b></span>
                            )}
                        </div>
                    </div>

                </div>
            </div>

            <StudentInstructorChat
                open={openChat}
                handleClose={() => {
                    setOpenChat(false);
                    setConversationId(0);
                }}
                instructorId={instructorId}
                instructorName={instructorName}
                isChatStarted={isChatStarted}
                conversationId={conversationId}
            />

        </div>
    );
};
